import React from "react";
import LegalPage from "../../components/Legal/LegalPage.jsx";
import termsOfService from "./termsOfServiceData.js";

const Terms = () => <LegalPage policy={termsOfService} />;

export default Terms;
